import { TUTORIALS } from "./tutorials.generated";

export const TUTORIAL_AREAS: Record<
  string,
  { icon: string; description: string; navTitle?: string }
> = {
  "Team access": {
    icon: "solar:users-group-rounded-linear",
    description: "Who can sign in and what they can do",
  },
  Contacts: {
    icon: "solar:user-id-linear",
    description: "Find, organize and export patients",
  },
  "Inbox and messaging": {
    icon: "solar:chat-round-dots-linear",
    description: "Reply, assign and keep conversations moving",
  },
  "Workspace settings": {
    icon: "solar:settings-linear",
    description: "How the workspace is configured",
  },
  "Appointments and clinic": {
    icon: "solar:calendar-linear",
    description: "Bookings, outcomes and the clinic day",
    navTitle: "Appointments",
  },
  "Echo AI": {
    icon: "solar:magic-stick-3-linear",
    description: "What Echo learns and suggests",
  },
};

export const tutorialGroupSlug = (group: string): string =>
  group
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");

export const tutorialAreaPath = (group: string): string =>
  `/tutorials/${tutorialGroupSlug(group)}`;

export const TUTORIAL_GROUPS = [
  ...new Set(TUTORIALS.map(({ group }) => group)),
];
const recordings = [
  ...new Map(TUTORIALS.map((tutorial) => [tutorial.flowId, tutorial])).values(),
];

export const TUTORIAL_COUNT = recordings.length;
export const TUTORIAL_MINUTES = recordings.reduce(
  (total, tutorial) => total + Math.max(1, Math.ceil(tutorial.seconds / 60)),
  0,
);
export const TUTORIAL_INTRO =
  "Short walkthroughs of ClinicPilot. Watch one, then do it yourself.";
